export default __webpack_public_path__ + "static/media/alarma.497a05b7.svg";